export enum EncounterActionTypes {
    API_RESPONSE_SUCCESS = '@@encounter/API_RESPONSE_SUCCESS',
    API_RESPONSE_ERROR = '@@encounter/API_RESPONSE_ERROR',
    ADD_ENCOUNTER = '@@encounter/ADD_ENCOUNTER',
    EDIT_ENCOUNTER = '@@encounter/EDIT_ENCOUNTER',
    GET_ENCOUNTER = '@@encounter/GET_ENCOUNTER',
    GET_ENCOUNTERS = '@@encounter/GET_ENCOUNTERS',
    GET_DISCOUNT = '@@encounter/GET_DISCOUNT',
    GET_PATIENT_ENCOUNTERS = '@@encounter/GET_PATIENT_ENCOUNTERS',
    ADD_ENCOUNTER_TEST = '@@encounter/ADD_ENCOUNTER_TEST',
    UPDATE_ENCOUNTER_TEST_DATA = '@@encounter/UPDATE_ENCOUNTER_TEST_DATA',
    GET_ENCOUNTER_ADDRESS_INFO = '@@encounter/GET_ENCOUNTER_ADDRESS_INFO',
    GET_ENCOUNTER_TEST_DATA = '@@encounter/GET_ENCOUNTER_TEST_DATA',
    RESET = '@@encounter/RESET',
    RESET_SUCCESS = '@@encounter/RESET_SUCCESS',
    RESET_ERROR = '@@encounter/RESET_ERROR',
}
